/**
 * StatKpiBand — the 5-tile KPI row (Total/Active projects, work items done
 * 30d, finish date, open RAID) as ONE component, matching the STAT_KPIS
 * builtin (BuiltinWidget.java: "wraps the whole 5-tile KPI band as one
 * component"). Composes the existing StatTile/StatTileText — same five
 * destinations, icons and tones PortfolioDashboardPage/AccountDashboardPage
 * compute inline today. Owns no data fetching — fed entirely by props from
 * StatKpisHost (this same task), which supplies GLOBAL- or ACCOUNT-scoped
 * values from the same queries those pages used.
 */
import {
  StatTile,
  StatTileText,
  IconStatProjects,
  IconStatActive,
  IconStatDone,
  IconStatCalendar,
  IconStatAlert,
} from './StatTile';

export interface StatKpiBandProps {
  totalProjects: number;
  activeProjects: number;
  crsDoneLast30: number;
  finishDate: string | null;
  /** "Portfolio Finish" (GLOBAL) | "Forecast Finish" (ACCOUNT). */
  finishLabel: string;
  finishTestId: string;
  openRaidCount: number;
  /** "across portfolio" (GLOBAL) | "open" (ACCOUNT). */
  openRaidSub: string;
}

export function StatKpiBand({
  totalProjects,
  activeProjects,
  crsDoneLast30,
  finishDate,
  finishLabel,
  finishTestId,
  openRaidCount,
  openRaidSub,
}: StatKpiBandProps) {
  return (
    <div style={{ display: 'grid', gridTemplateColumns: 'repeat(5, 1fr)', gap: 14, height: '100%' }}>
      <StatTile label="Total Projects" value={totalProjects} icon={<IconStatProjects />} sub="non-cancelled" />
      <StatTile label="Active Projects" value={activeProjects} icon={<IconStatActive />} sub="in delivery" />
      <StatTile
        label="Work items done (30d)"
        value={crsDoneLast30}
        icon={<IconStatDone />}
        tone="positive"
        sub="last 30 days"
      />
      <StatTileText
        label={finishLabel}
        value={finishDate}
        icon={<IconStatCalendar />}
        sub="max forecast"
        testId={finishTestId}
      />
      <StatTile label="Open RAID" value={openRaidCount} icon={<IconStatAlert />} tone="warning" sub={openRaidSub} />
    </div>
  );
}
